export default "__VITE_ASSET__HfOV4SuF__"